export const SectionTitle = ({ children, testid }) => (
    <div>
        <div className="flex items-center justify-center gap-4">
            <span className="hidden sm:block h-px flex-1 max-w-40 bg-gradient-to-l from-[#c9a24b]/60 to-transparent" />
            <span className="hidden sm:block w-1.5 h-1.5 rotate-45 border border-[#c9a24b]" />
            <h2 className="font-caps gold-text text-base sm:text-lg tracking-[0.2em] text-center" data-testid={testid}>
                {children}
            </h2>
            <span className="hidden sm:block w-1.5 h-1.5 rotate-45 border border-[#c9a24b]" />
            <span className="hidden sm:block h-px flex-1 max-w-40 bg-gradient-to-r from-[#c9a24b]/60 to-transparent" />
        </div>
        <div className="flex justify-center mt-2">
            <img loading="lazy" decoding="async" src="/images/ornamento.webp" alt="" aria-hidden="true" className="w-36 opacity-90" />
        </div>
    </div>
);
